import mixpanel from 'mixpanel-browser';
import { Box, Typography, Link } from '@mui/material';

import { OUR_MISSION, MISSION_DESCRIPTION, JOIN_OUR_LENDER_NETWORK } from './constants';

export const SbsMission = ({ userId }) => {
  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      sx={{ m: 0, mb: { xs: 0, sm: 2 } }}
      flexDirection={{ xs: 'column-reverse', md: 'row' }}
      gap={5}
    >
      {/* Visual Section */}
      <Box flex={1} display="flex" justifyContent="center" alignItems="center" mb={4}>
        <Box
          component="img"
          src="https://res.cloudinary.com/amunoali/image/upload/v1742152953/CashClever/43_nfpjbf.png" // Replace with your image URL
          alt="Placeholder"
          sx={{
            maxWidth: { xs: 343, lg: 465 },
            minHeight: { xs: 300, lg: 407 },
            width: '100%',
            borderRadius: '32px',
            objectFit: 'cover',
            filter: 'grayscale(80%)',
          }}
        />
      </Box>
      {/* Text Section */}
      <Box flex={1} sx={{ textAlign: 'center' }}>
        <Box maxWidth={{ xs: 343, lg: 556 }} mx={'auto'}>
          <Typography
            gutterBottom
            sx={{
              textWrap: 'pretty',
              fontSize: { xs: '30px', md: '42px' },
              fontWeight: '700',
              lineHeight: { xs: '38.4px', md: '61.44px' },
              fontFamily: 'sans-serif',
            }}
          >
            {OUR_MISSION}
          </Typography>

          <Typography
            sx={{
              textWrap: 'pretty',
              fontSize: { xs: '14px', md: '16px' },
              lineHeight: { xs: '22.4px', md: '28.8px' },
              color: '#727272',
              px: { xs: '0', sm: '0', md: '3rem' },
              mb: 4,
              fontFamily: 'sans-serif',
            }}
            gutterBottom
          >
            {MISSION_DESCRIPTION}
          </Typography>

          <Link
            sx={{
              '&:hover': { textDecoration: 'none' },
              color: 'white',
              borderRadius: '1rem',
              backgroundColor: 'black',
              color: 'white',
              textTransform: 'initial',
              padding: 2,
              pl: 3.5,
              pr: 3.5,
              fontSize: 14,
              fontFamily: 'sans-serif',
              fontWeight: 600,
              textDecoration: 'none',
            }}
            href="/partner"
            onClick={() => {
              mixpanel.track('Join Our Network', { path: '/about', distinct_id: userId });
            }}
          >
            {JOIN_OUR_LENDER_NETWORK}
          </Link>
          <div style={{ visibility: 'hidden' }}>-</div>
        </Box>
      </Box>
    </Box>
  );
};
